import { RiLockPasswordLine, RiMailLine } from "react-icons/ri";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie"
export default function ResetPassword() {
  const [form, setForm] = useState({ email: ""});
  const [error, setError] = useState("");
  const queryClient = useQueryClient()
 const {
    mutate: Send,
    isPending,
    isError,
    
  } = useMutation({
    mutationKey: ["auth"],
    mutationFn: async ({ email}) => {
      const token = Cookies.get("engageLagos");

  if (!token) {
    throw new Error("You are not authenticated. Please log in again.");
  }
  const res = await fetch(
    "https://api.engagelagos.com/auth/request-password-reset",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email }),
    }
  );

const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Password reset failed");
  }

 

  return data;
},

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auth"] });
      toast.success("Account created successfully!");
    },
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
   
    setError("");
    Send(form);
  };

  const inputGroup =
    "flex items-center gap-3 w-full border-b border-gray-300 py-3 focus-within:border-indigo-600 transition-all";
  const inputClass = "w-full outline-none bg-transparent text-gray-700  text-base";

  return (
    <div className="min-h-screen w-full bg-slate-50 flex flex-col justify-center px-6 sm:px-12 lg:px-24 py-12 font-sans">
      <div className="mb-12 text-center">
        <h1 className="text-3xl font-bold text-slate-900">Forgotten Password</h1>
        <p className="text-gray-500 mt-2">Change your password securely</p>
      </div>

      <form className="w-full max-w-2xl mx-auto space-y-6" onSubmit={handleSubmit}>
       

        <div className="space-y-1">
          <label className="text-sm font-medium text-gray-700">Email Address</label>
          <div className={inputGroup}>
            <RiMailLine size={20} className="text-gray-400" />
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={form.email}
              onChange={handleChange}
              className={inputClass}
              required
            />
          </div>
        </div>

        {error && <p className="text-red text-center font-medium">{error}</p>}

        <button className="w-full bg-indigo-600 py-3 rounded-md text-white font-semibold hover:bg-indigo-700 transition-all">
        {
            isPending ? "Submitting..." : "Submit"
        }
        </button>
      </form>
    </div>
  );
}
